/**
 * Created by mh on 17/12/12
 */
import vue from 'vue';
import http from './http.js';
import { getCookie } from './utils'
import { wxORzfb } from './config'

export function initZfbJSSDK() {
	return new Promise(function (resolve, reject) {
		window.init = function () {
			resolve(zfbSdk)//注意这里
		}
		var script = document.createElement("script");
		script.type = "text/javascript";
		script.src = "https://gw.alipayobjects.com/as/g/h5-lib/alipayjsapi/3.1.1/alipayjsapi.min.js?callback=init";
		script.onerror = reject;
		document.head.appendChild(script);
	})
}

export function initWxJSSDK() {
	let url = window.location.href;
	// let url = location.href.split('#')[0];
	// let url = 'http://wx.clothes.yooinfo.com/';
	let authorizer_appid = getCookie('authorizer_appid');
	// var wxORzfb = window.location.host;
	if (wxORzfb == 'wx') {
		//微信授权
		wxGetJsApiConfig({ data: { url: encodeURIComponent(url.split('#')[0]), authorizer_appid: authorizer_appid } }).then(function (data) {
			var configparams = data.Content.split(',');
			vue.wechat.config({
				debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
				appId: configparams[0], // 必填，公众号的唯一标识
				timestamp: configparams[1], // 必填，生成签名的时间戳
				nonceStr: configparams[2], // 必填，生成签名的随机串
				signature: configparams[3], // 必填，签名，见附录1
				// jsApiList: ['scanQRCode']
				jsApiList: ['closeWindow', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone', 'uploadImage', 'chooseImage', 'previewImage', 'downloadImage', 'getLocation', 'openLocation', 'scanQRCode', 'translateVoice']
				// 必填，需要使用的JS接口列表，所有JS接口列表见附录2
			});
			vue.wechat.ready(function (res) {
				console.log(res)
			});
			vue.wechat.error(function (res) {//通过error接口处理失败验证
				// config信息验证失败会执行error函数
				console.log(res);
			});
		});
	}
}
export function wxGetJsApiConfig(option = {}) {
	option.url = option.url || '/api/app/thirdPlatform/wxGetJsApiConfig?url=' + option.data.url + '&authorizer_appid=' + option.data.authorizer_appid;
	return http.post(option);
};

/**
 * 获取我的信息
 * @param {*} option
 */
export function getProfile(option = {}) {
	option.url = option.url || '/api/app/userinfo/getCurrentUsers';
	return http.get(option);
};

export function getHeadInfo(option = {}) {
	option.url = option.url || '/api/wxapp/userInfo/getCurrentUserHeadInfo';
	return http.get(option)
}

export function getAddressList(option = {}) {
	option.url = option.url || '/api/app/address/getList';
	return http.get(option);
};
export function getAddress(option = {}) {
	option.url = option.url || '/api/app/address/get/' + option.data.recordId;
	return http.get(option);
};
export function getDefaultAddress(option = {}) {
	option.url = option.url || '/api/app/address/getDefault';
	return http.get(option);
};

export function checkAddressPartner(option = {}) {
	option.url = option.url || '/api/saveEarth/checkAddressPartner';
	return http.post(option);
};

export function addAddress(option = {}) {
	option.url = option.url || '/api/app/address/add';
	return http.post(option);
};
export function updateAddress(option = {}) {
	option.url = option.url || '/api/app/address/update';
	return http.post(option);
};
export function deleteAddress(option = {}) {
	option.url = option.url || '/api/app/address/delete/' + option.data.recordID;
	return http.post(option);
};

export function getYuBookRegionList(option = {}) {
	option.url = option.url || 'yuBook/getYuBookRegionList';
	option.data = { parentId: 'Area_China' };
	return http.post(option);
};

export function getRegionList(option = {}) {
	option.url = option.url || '/api/app/region/getRegionList';
	option.data = { parentId: 'Area_China' };
	return http.post(option);
};
export function getRegionTownList(option = {}) {
	option.url = option.url || '/api/app/region/getRegionByParent';
	return http.post(option);
};
export function appointmentYuBook(option = {}) {
	option.url = option.url || 'yuBook/book';
	return http.post(option);
};

export function appointment(option = {}) {
	option.url = option.url || '/api/app/orders/book';
	return http.post(option);
};

export function yueAppointment(option = {}) {
	option.url = option.url || '/api/app/orders/yuebook';
	return http.post(option);
};

export function birdappointment(option = {}) {
	option.url = option.url || '/api/app/orders/birdbook';
	return http.post(option);
};

export function cancelOrders(option = {}) {
	option.url = option.url || '/api/app/orders/cancelBook/' + option.data.orderId;
	return http.post(option);
};


export function getCertificateList(option = {}) {
	option.url = option.url || '/api/app/certificateInfo/getList';
	return http.post(option);
};
export function getCertificate(option = {}) {
	option.url = option.url || '/api/app/certificateInfo/getByOrderId/' + option.orderId;
	return http.get(option);
};

export function pickCertificate(option = {}) {
	option.url = option.url || '/api/app/orders/pickCertificate/' + option.data.orderId;
	return http.post(option);
};



export function getOrderList(option = {}) {
	option.url = option.url || '/api/app/orders/getList';
	return http.post(option);
};
export function getOrder(option = {}) {
	option.url = option.url || '/api/app/orders/getOrder/' + option.data.orderId;
	return http.get(option);
};
export function getUnPickOrderList(option = {}) {
	option.url = option.url || '/api/app/orders/getUnPickOrderList';
	return http.post(option);
};

export function checkQrCodeUsed(option = {}) {
	option.url = option.url || '/api/app/orders/checkQrCodeUsed/' + option.data.qrCode;
	return http.get(option);
};
export function getQrCode(option = {}) {
	option.url = option.url || '/api/app/orders/getQrCode/' + option.data.orderId + '/' + option.data.qrCode;
	return http.get(option);
};
export function saveQrCode(option = {}) {
	option.url = option.url || '/api/app/orders/saveQrCode/' + option.data.orderId + '/' + option.data.qrCode;
	return http.post(option);
};

export function getExchangeBean(option = {}) {
	option.url = option.url || '/api/app/orderHistoryInfo/getExchangeBean/' + option.data.orderId;
	return http.get(option);
};

export function getOrderHistoryInfo(option = {}) {
	option.url = option.url || '/api/app/orderHistoryInfo/get/' + option.data.orderId;
	return http.get(option);
};

export function getGoldRecordList(option = {}) {
	option.url = option.url || '/api/app/goldRecord/getList/' + option.data.payType + '/' + option.data.pageIndex + '/' + option.data.pageSize;
	return http.get(option);
};

export function getActivityList(option = {}) {
	option.url = option.url || '/api/app/activity/getList';
	return http.post(option);
};

export function getActivity(option = {}) {
	option.url = option.url || '/api/app/activity/get/' + option.data.activityId;
	return http.get(option);
};


export function getQrCodeSerialNumber(option = {}) {
	option.url = option.url || '/api/app/wxQrCode/getQrCodeSerialNumber?qrData=' + encodeURIComponent(option.data.qrData) + (option.data.activityId ? '&activityId=' + option.data.activityId : '');
	return http.get(option);
};

export function createActivityOrder(option = {}) {
	option.url = option.url || '/api/app/orders/createActivityOrder';
	return http.post(option);
};

export function createActivityOrderYuexiu(option = {}) {
	option.url = option.url || '/api/app/orders/createActivityOrderYuexiu';
	return http.post(option);
};


export function getTerminal(option = {}) {
	option.url = option.url || '/api/app/terminal/get/' + option.data.terminalId + "/" + option.data.key;
	return http.get(option);
};
export function printTerminalQrCode(option = {}) {
	option.url = option.url || '/api/app/orders/printTerminalQrCode';
	return http.post(option);
};
export function checkHasPrinted(option = {}) {
	option.url = option.url || '/api/app/orders/checkHasPrinted';
	return http.post(option);
};
export function checkPrintOrderStatus(option = {}) {
	option.url = option.url || '/api/app/orders/getOrderStatus/' + option.data.orderId;
	return http.get(option);
};
export function removeTerminalOrder(option = {}) {
	option.url = option.url || '/api/app/orders/removeTerminalOrder/' + option.data.orderId + "/" + option.data.key;
	return http.post(option);
};

export function getSaveEarthNewsList(option = {}) {
	option.url = option.url || '/api/saveEarth/getNewsList';
	return http.post(option);
};

export function getNewsList(option = {}) {
	option.url = option.url || '/api/app/news/getNewsList';
	return http.post(option);
};

export function getNews(option = {}) {
	option.url = option.url || '/api/app/news/getNews';
	return http.post(option);
};


export function checkYuBookOpenArea(option = {}) {
	option.url = option.url || 'yuBook/checkYuBookOpenArea/' + option.data.areaCode;
	return http.get(option);
};

export function checkOpenArea(option = {}) {
	option.url = option.url || '/api/app/address/checkOpenArea/' + option.data.areaCode;
	return http.get(option);
};


export function loadMapMarkerTerminals(option = {}) {
	option.url = option.url || '/api/app/terminal/loadMapMarkerTerminals';
	return http.get(option);
};
export function getTerminalDetail(option = {}) {
	option.url = option.url || '/api/app/terminal/getTerminalDetail/' + option.data.terminalId;
	return http.get(option);
};
export function openDoor(option = {}) {
	option.url = option.url || '/api/app/terminal/openDoor/' + option.data.terminalId;
	return http.post(option);
};
export function getOpenDoorStatus(option = {}) {
	option.url = option.url || '/api/app/terminal/getOpenDoorStatus/' + option.data.terminalId + '/' + option.data.serialNumber;
	return http.post(option);
};
export function finishWorkOrder(option = {}) {
	option.url = option.url || '/api/app/support/finishWorkOrder/' + option.data.orderId;
	return http.post(option);
};
export function supportCancelOrders(option = {}) {
	option.url = option.url || '/api/app/support/cancelOrders/' + option.data.orderId + "/" + option.data.cancelType;
	return http.post(option);
};

export function getTerminalList(option = {}) {
	option.url = option.url || '/api/app/terminal/getTerminalList';
	return http.post(option);
};

export function installTerminal(option = {}) {
	option.url = option.url || '/api/app/terminal/installTerminal';
	return http.post(option);
};


export function getSignList(option = {}) {
	option.url = option.url || '/api/app/sceneSign/getList';
	return http.post(option);
};
export function manualSign(option = {}) {
	option.url = option.url || '/api/app/sceneSign/manualSign';
	return http.post(option);
};
export function autoSign(option = {}) {
	option.url = option.url || '/api/app/sceneSign/autoSign';
	return http.post(option);
};
export function getWorkOrderAmount(option = {}) {
	option.url = option.url || '/api/app/support/getWorkOrderAmount';
	return http.get(option);
};

export function getMyWorkOrderList(option = {}) {
	option.url = option.url || '/api/app/support/getMyWorkOrderList';
	return http.post(option);
};

export function getWorkOrder(option = {}) {
	option.url = option.url || '/api/app/support/getWorkOrder/' + option.data.orderId;
	return http.get(option);
};

export function getMyMessageList(option = {}) {
	option.url = option.url || '/api/app/support/getMyMessageList';
	return http.post(option);
};

export function getMessage(option = {}) {
	option.url = option.url || '/api/app/support/getMessage/' + option.data.messageId;
	return http.get(option);
};
export function exchangeBean(option = {}) {
	option.url = option.url || '/api/app/goldRecord/exchangeBean/' + option.data.userId + "/" + option.data.amount;
	return http.post(option);
};
export function exchangeCash(option = {}) {
	option.url = option.url || '/api/app/goldRecord/applyExchangeCash/' + option.data.amount;
	return http.post(option);
};
export function getExchangeAccount(option = {}) {
	option.url = option.url || '/api/app/goldRecord/getExchangeAccount';
	return http.get(option);
};

export function getPartnerAppointImage(option = {}) {
	option.url = option.url || '/api/app/partner/getPartnerAppointImage/' + option.data.partnerId;
	return http.get(option);
};
export function getPartner(option = {}) {
	option.url = option.url || '/api/app/partner/getPartner/' + option.data.partnerId;
	return http.get(option);
};

/**
 * validCode
 */
// 发送验证码
export function sendMobileCode(option = {}) {
	option.url = option.url || '/api/app/userinfo/sendMobileCode/' + option.data.mobile;
	return http.post(option);
};
// 验证验证码
export function validMobileCode(option = {}) {
	// console.log(option);
	option.url = option.url || '/api/app/userinfo/validMobileCode';
	return http.post(option);
};

// 支付宝发验证验证码
export function alipayValidMobileCode(option = {}) {
	// console.log(option);
	option.url = option.url || '/api/app/alipayThirdPlatform/appointmentLogin';
	return http.post(option);
};

// 支付宝发验证验证码
export function alipaySendMobileCode(option = {}) {
	// console.log(option);
	option.url = option.url || '/api/app/alipayThirdPlatform/sendMobileCode/' + option.data.mobile;
	return http.post(option);
};

/**
 * user
 */
// 登陆
export function login(option = {}) {
	option.url = option.url || '/api/user/loginByCode';
	return http.post(option);
};
// 退出登陆
export function logout(option = {}) {
	option.url = option.url || '/api/user/logout';
	return http.get(option);
};
// 用户信息
export function getUserInfo(option = {}) {
	option.url = option.url || '/api/user/info';
	return http.get(option);
};
// 更新用户信息
export function updateUserInfo(option = {}) {
	option.url = option.url || '/api/user/update';
	return http.post(option);
};
// 上传头像
export function uploadHeadImg(option = {}) {
	option.url = option.url || '/api/user/headImg';
	option.config = {
		headers: {
			'Content-type': 'multipart/form-data'
		}
	};
	return http.post(option);
};
// 绑定手机
export function bindMobile(option = {}) {
	option.url = option.url || '/api/user/bindMobile';
	return http.post(option);
};
// 获得用户统计
export function getUserCount(option = {}) {
	option.url = option.url || '/api/user/count';
	return http.get(option);
};

/**
 * app
 */
// 获取地区列表
export function region(option = {}) {
	option.url = option.url || '/api/app/region';
	return http.get(option);
}

// 解析经纬度
export function geocoder(location) {
	return vue.jsonp('https://apis.map.qq.com/ws/geocoder/v1/', {
		callbackQuery: 'cb',
		location: location,
		coord_type: 1,
		key: 'CTGBZ-RW6WX-2ER43-ZAFY7-SU3I3-GWBPK',
		output: 'jsonp'
	});
};

export function getProductList(option = {}) {
	option.url = option.url || '/shop/wxapp/relationTag/getAppointmenntProductRegList'
	return http.post(option)
}

//获取shop项目公益活动列表
export function getWelfareList(option = {}) {
	option.url = option.url || '/shop/wxapp/welfareActivity/getList'
	return http.post(option)
}
//获取环境教育列表
export function getEnvEducationList(option = {}) {
	option.url = option.url || '/api/app/news/getNewsList'
	return http.post(option);
}

//获取环境教育文章详情
export function getEnvEducationDetail(option = {}) {
	option.url = option.url || '/api/app/news/getNews'
	return http.post(option);
}

//获取文章
export function getAticleNews(option = {}) {
	option.url = '/shop/wxapp/news/getNews/' + option.data.newsId
	return http.get(option);
}

//获取所有附近回收箱
export function getAllNearTerminalList(option = {}) {
	option.url = option.url || '/api/app/terminal/getAllNearTerminalList';
	return http.post(option);
};

//获取所有附近网点
export function getPartnerList(option = {}) {
	option.url = option.url || '/api/saveEarth/getPartnerList';
	return http.post(option);
};

//获取省份单价和最小支付金额
export function getPriceWeight(option = {}) {
	option.url = option.url || '/api/wxapp/partner/getPriceWeight';
	return http.get(option);
};

//预约箱子
export function appointmentTerminal(option = {}) {
	option.url = option.url || '/api/app/terminal/appointmentTerminal';
	return http.post(option);
};

//预约箱子过期时间
export function getTerminalAppointmentTime(option = {}) {
	option.url = option.url || '/api/app/terminal/getTerminalAppointmentTime';
	return http.get(option);
};


//获取社区服务文章
export function getCommunityNews(option = {}) {
	option.url = '/shop/wxapp/news/getNews/' + option.data.newsId
	return http.get(option);
}

//获取我的消息联系人
export function getMyRosters(option = {}) {
	option.url = '/shop/wxapp/chatMessage/getMyRosters'
	return http.get(option);
}
//获取Roster信息
export function getRoster(option = {}) {
	option.url = '/shop/wxapp/chatMessage/getRoster/' + option.receiver
	return http.get(option);
}
//获取消息列表
export function getMessageList(option = {}) {
	option.url = '/shop/wxapp/chatMessage/getMessageList'
	return http.post(option);
}
//获取最新消息列表
export function getNewestMessageList(option = {}) {
	option.url = '/shop/wxapp/chatMessage/getNewestMessageList'
	return http.post(option);
}
export function getMessageHistoryList(option = {}) {
	option.url = '/shop/wxapp/chatMessage/getMessageHistoryList'
	return http.post(option);
}

export function sendMessage(option = {}) {
	option.url = '/shop/wxapp/chatMessage/sendMessage'
	return http.post(option);
}
export function sendMessageType(option = {}) {
	option.url = '/shop/wxapp/chatMessage/sendMessageType/' + option.data.objectType + "/" + option.data.objectId
	return http.post(option);
}

export function readAllMessage(option = {}) {
	option.url = '/shop/wxapp/chatMessage/readAllMessage/' + option.receiver
	return http.post(option);
}  


// WEBPACK FOOTER //
// ./src/common/js/api.js